import { prefersReducedMotion } from '@theme/utilities';

/**
 * @param {HTMLElement} target
 */
function openAccordionForTarget(target) {
  const accordion = target.closest('accordion-custom');

  if (!(accordion instanceof HTMLElement)) return;

  const details = accordion.querySelector('details');

  if (details instanceof HTMLDetailsElement && !details.open) {
    details.open = true;
  }
}

/**
 * @returns {number}
 */
function getScrollOffset() {
  const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
  const scrollMargin = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--scroll-margin')) || 0;

  return headerHeight + scrollMargin;
}

/**
 * @param {HTMLElement} target
 * @param {{ updateHash?: boolean }} [options]
 */
function scrollToAnchor(target, { updateHash = true } = {}) {
  openAccordionForTarget(target);

  const behavior = prefersReducedMotion() ? 'instant' : 'smooth';

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const offset = getScrollOffset();
      const top = target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({ top, behavior });

      if (updateHash && target.id) {
        history.pushState(null, '', `#${target.id}`);
      }
    });
  });
}

/**
 * @param {string} anchorId
 * @param {{ updateHash?: boolean }} [options]
 * @returns {boolean}
 */
function navigateToAnchor(anchorId, options = {}) {
  if (!anchorId) return false;

  const target = document.getElementById(anchorId);

  if (!(target instanceof HTMLElement)) return false;

  scrollToAnchor(target, options);
  return true;
}

/**
 * @param {Event} event
 */
function handleAnchorLinkClick(event) {
  const link = event.currentTarget;

  if (!(link instanceof HTMLAnchorElement)) return;

  const anchorId = link.hash.replace(/^#/, '');

  if (!anchorId) return;

  const target = document.getElementById(anchorId);

  if (!(target instanceof HTMLElement)) return;

  event.preventDefault();
  scrollToAnchor(target);
}

function handleInitialHash() {
  const anchorId = window.location.hash.replace(/^#/, '');

  if (!anchorId) return;

  navigateToAnchor(anchorId, { updateHash: false });
}

function initAnchorLinks() {
  document.querySelectorAll('[data-anchor-link]').forEach((link) => {
    link.addEventListener('click', handleAnchorLinkClick);
  });

  handleInitialHash();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnchorLinks, { once: true });
} else {
  initAnchorLinks();
}
